import { Eye, KeyRound, Laptop, ShieldOff } from "lucide-react";

import { Section, SectionHeading } from "@/components/ui/Section";
import { AuroraField } from "@/components/visuals/AuroraField";
import { useLocale } from "@/i18n";

export function PrivacyFirst({ heading = true }: { heading?: boolean }) {
  const { t } = useLocale();
  const p = t.privacy.points;

  const points = [
    { icon: ShieldOff, ...p.failClosed },
    { icon: Laptop, ...p.onDevice },
    { icon: Eye, ...p.visible },
    { icon: KeyRound, ...p.noKeys },
  ];

  return (
    <div className="relative overflow-hidden">
      <AuroraField variant="soft" />
      <Section id="privacy" className="relative">
        {heading ? (
          <SectionHeading title={t.privacy.title} subtitle={t.privacy.subtitle} />
        ) : null}

        <div className="mt-16 grid gap-5 md:grid-cols-2">
          {points.map(({ icon: Icon, title, body }) => (
            <article
              key={title}
              className="card-surface flex flex-col p-7 md:flex-row md:gap-5"
            >
              <span className="mb-5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-500/10 ring-1 ring-emerald-400/20 md:mb-0">
                <Icon size={19} className="text-emerald-300" aria-hidden />
              </span>
              <div>
                <h3 className="text-lg font-semibold text-cream-50">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-cream-100/58">
                  {body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </Section>
    </div>
  );
}
